import { BulkActionResultTabs } from "components/BulkActions/types";
import TabWithCounter from "ds/components/Tab/WithCounter";

import { getTabName } from "./helpers";

type BulkActionsDrawerResultsStepTab = {
  currentTab: BulkActionResultTabs;
  result: BulkActionResultTabs;
  counter?: number;
  setTab: (tab: BulkActionResultTabs) => void;
  labelOverride?: string;
  idPrefix: string;
};

const BulkActionsDrawerResultsStepTabsTab = ({
  currentTab,
  result,
  counter,
  setTab,
  labelOverride,
  idPrefix,
}: BulkActionsDrawerResultsStepTab) => {
  return (
    <TabWithCounter
      isActive={currentTab === result}
      id={`${idPrefix}-${result}`}
      label={labelOverride ?? getTabName(result)}
      count={counter || 0}
      onClick={() => setTab(result)}
    />
  );
};

export default BulkActionsDrawerResultsStepTabsTab;
